var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduktuebersicht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 25,
    fill: "#3141D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 85,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 87V40.4545H65.0511C68.7027 40.4545 71.6875 41.1136 74.0057 42.4318C76.339 43.7348 78.0663 45.5 79.1875 47.7273C80.3087 49.9545 80.8693 52.4394 80.8693 55.1818C80.8693 57.9242 80.3087 60.4167 79.1875 62.6591C78.0814 64.9015 76.3693 66.6894 74.0511 68.0227C71.733 69.3409 68.7633 70 65.142 70H53.8693V65H64.9602C67.4602 65 69.4678 64.5682 70.983 63.7045C72.4981 62.8409 73.5966 61.6742 74.2784 60.2045C74.9754 58.7197 75.3239 57.0455 75.3239 55.1818C75.3239 53.3182 74.9754 51.6515 74.2784 50.1818C73.5966 48.7121 72.4905 47.5606 70.9602 46.7273C69.4299 45.8788 67.3996 45.4545 64.8693 45.4545H54.9602V87H49.3239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduktuebersicht);
export default __webpack_public_path__ + "static/media/Produktuebersicht.c072c536927de81bfa77430e773faa1d.svg";
export { ForwardRef as ReactComponent };